import { render, staticRenderFns } from "./createAndEdit.vue?vue&type=template&id=64c9bd4c&scoped=true&"
import script from "./createAndEdit.vue?vue&type=script&lang=js&"
export * from "./createAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./createAndEdit.vue?vue&type=style&index=0&id=64c9bd4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9bd4c",
  null
  
)

export default component.exports